<template>
	
	<div class="default-bg">
		<normalBar title="退款详情"></normalBar>
		<div  v-if="refundList&&refundList.length">
			<div class="cancel-info-sec">
				<div class="info-item" :class="{active:  item.status==1}" v-for="item in refundList">
					<span class="icon-circel"></span>
					<div class="text"><div>
						<p>{{item.option}}</p>
						<p class="text-grey">{{item.createdTime}}</p>
					</div></div>

				</div>
			</div>
			<div class="refund-tips">
				若退款迟迟未到账，请与客服联系：400-999-6666
			</div>
			<span class="line"></span>
		</div>
		<div class="text-center" v-else>暂无数据</div>
	</div>

	


</template>


<script>
	import Vue from 'vue';
	import { Picker } from '@/js/mint-ui';
	import { Popup } from '@/js/mint-ui';
	Vue.component(Popup.name, Popup);
	Vue.component(Picker.name, Picker);
	import normalBar from '@/components/common/navbar/normalBar'
	import api from '@/api/api'

	export default {
		data(){
			return {
				refundList: [],
				secondType: 0,
			}
		},
		components: {
			normalBar
		},
		mounted(){
			let self = this;
			let orderCode = this.$route.params.orderCode;
			api.get('api/appclient/v2/order/refundList/'+orderCode,'',function(json){
				let res = json.body;
				self.refundList = res.data;
				self.secondType = res.data[0].secondType;
			})	
		}

	}



</script>


<style lang="scss">
	@import '../../assets/css/mixin';

	.cancel-info-sec {
		position: relative;
		

		.info-item {
			margin-top: pxToRem(20px);
			display: flex;
			justify-content: center;
			align-items: center;
			
			.text {
				padding-left: pxToRem(25px);
				margin-left: pxToRem(40px);
				width: pxToRem(594px);
				height: pxToRem(140px);
				color: #BDBDBD;
				background-color: #fff;
				display: inline-flex;
				align-items: center;
				.text-grey {
					margin-top: pxToRem(10px);
				}
			}

			.icon-circel {
				display: inline-block;
				width: 10px;
				height: 10px;
				border: 1px solid #ccc;
				border-radius: 50%;
				position: relative;
				background: #eee;
				z-index: 999;
			}

			&.active {
				.text {
					color: #191919;
				}
				.icon-circel {
					border-color: #D8331D;
				}
			}
		}


	}

	.line  {
		width: 1px;
		background-color: #ccc;
		position: absolute;
		left: pxToRem(58px);
		top: 50px;
		bottom: 0;
		z-index: 0;
	}
	
	.refund-tips {
		position: absolute;
		bottom: pxToRem(50px);
		width: 100%;
		text-align: center;

	}

	.text-center {
		margin: 50px 0;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// orderRefundDetails.vue?460dad88